export type ReactionsSummary = Record<string, number>

export interface ReactionState {
  summary: ReactionsSummary
  myReaction: string | null
}

const decrement = (summary: ReactionsSummary, emoji: string): number =>
  Math.max(0, (summary[emoji] ?? 0) - 1)

/**
 * Resultado de o participante clicar em `emoji`, dado o resumo e a reação atual
 * vindos do servidor. Puro de propósito: a `ReactionBar` usa isso como palpite
 * otimista e descarta o palpite assim que o payload real chega.
 *
 * A api mantém uma reação por participante/post, então clicar num emoji
 * diferente move a reação em vez de somar uma segunda.
 */
export const applyReactionToggle = (
  summary: ReactionsSummary,
  myReaction: string | null | undefined,
  emoji: string
): ReactionState => {
  if (myReaction === emoji)
    return {
      summary: { ...summary, [emoji]: decrement(summary, emoji) },
      myReaction: null
    }

  const withoutPrevious = myReaction
    ? { ...summary, [myReaction]: decrement(summary, myReaction) }
    : { ...summary }

  return {
    summary: { ...withoutPrevious, [emoji]: (withoutPrevious[emoji] ?? 0) + 1 },
    myReaction: emoji
  }
}
